// extracted by mini-css-extract-plugin
export var bisolduoSprey = "product-header-module--bisolduoSprey--bziUo";
export var bisolduoSurup = "product-header-module--bisolduoSurup--PuFEH";
export var bisolnatur = "product-header-module--bisolnatur--6WL0G";
export var bisolviralSprey = "product-header-module--bisolviralSprey--IiUC0";
export var component = "product-header-module--component--kWoVW";
export var image = "product-header-module--image--9TSUE";
export var logo = "product-header-module--logo--qrbaN";